import { Box, Table } from '@mui/joy';
import React from 'react';
import BewertungsCard from './BewertungsCard';

function FragenViewer({ data, fragen, bw }) {
    function getpoints(idEntry, frageDef) {
        if (!idEntry || !Array.isArray(frageDef.bewertung)) return 0;
        const match = frageDef.bewertung.find((e) => e.id === idEntry.bewertung);
        return match?.point ?? 0;
    }
    return (
        <>
            <Table borderAxis="both" sx={{
                '& thead th:nth-child(1)': { width: '35%' }, '& thead th:nth-child(2)': { width: '5%' }, mb: 5,
                '& td': {
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',

                },

            }}>
                <thead>
                    <tr>
                        <th>Frage</th>
                        <th>Bewertung</th>
                        <th>Antwort</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(fragen) &&
                        fragen
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map((item, index) => {
                                const keys = Object.keys(item).filter(k => k !== "order");
                                const name = keys[0] || "Unbenannt";
                                return (
                                    <React.Fragment key={`${index}-${name}`}>
                                        <tr>
                                            <td colSpan={1} style={{ fontWeight: 'bold' }}>{name}</td>
                                            <td>

                                                {item[name].reduce((acc, frage) => {
                                                    const idEntry = data?.bewertung ? data.bewertung.find((a) => a.question === frage.name) : null;
                                                    return acc + getpoints(idEntry, frage);
                                                }, 0)}
                                            </td>
                                            <td />
                                        </tr>
                                        {Array.isArray(item[name]) &&
                                            item[name]
                                                .slice()
                                                .sort((a, b) => a.order - b.order)
                                                .map((frage, idx) => (

                                                    <tr key={`${index}-${idx}`}>
                                                        <td>{frage.name}</td>
                                                        <td><BewertungsCard id={data?.bewertung ? data.bewertung.find((a) => a.question === frage.name) : null} item={frage} /></td>
                                                        <td>{data?.questions ? data.questions.find((a) => a.question === frage.name)?.antwort : null}</td>
                                                    </tr>
                                                ))}
                                    </React.Fragment>
                                );
                            })}

                </tbody>
            </Table>
        </>
    );
}

export default FragenViewer;
